import JwtDecode from 'jwt-decode';
import moment from 'moment';
import 'moment-timezone';
import { logout } from '../store/actions/auth';

class accountHelpers {
  static setToken(token) {
    localStorage.setItem('token', token);
  }

  static setRefreshToken(token) {
    localStorage.setItem('refreshToken', token);
  }

  static setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  static getToken = (token = 'token') => localStorage.getItem(token);

  static removeLocalStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }

  static removeLocalStorageToAdmin() {
    localStorage.removeItem('AdminToken');
    localStorage.removeItem('AdminRefreshToken');
    localStorage.removeItem('AdminUser');

    sessionStorage.removeItem('AdminToken');
    sessionStorage.removeItem('AdminUser');
    sessionStorage.removeItem('AdminRefreshToken');
  }

  static setAdminData() {
    localStorage.setItem('AdminToken', this.getToken());
    localStorage.setItem('AdminRefreshToken', localStorage.getItem('refreshToken'));
    localStorage.setItem('AdminUser', localStorage.getItem('user'));

    sessionStorage.clear();
  }

  static getAdminData() {
    this.setToken(this.getAdminToken());
    this.setRefreshToken(this.getAdminToken());
    this.setUser(JSON.parse(localStorage.getItem('AdminUser')));
  }

  // static setTokenExpiresAt(expiresIn) {
  //   const now = new Date();
  //   const expiresAt = moment(now).add(expiresIn, 'm').valueOf();
  //   localStorage.setItem('tokenExpiresAt', expiresAt);
  // }

  static getPwdExpirationDaysLeft = () => {
    const user = this.getUser();
    let result = -1;
    if (user.pwdChangedUTC) {
      const now = moment().utc();
      const pwdExpiration = moment(user.pwdChangedUTC).add(90, 'days');
      result = pwdExpiration.diff(now, 'days');
    }
    return result;
  };

  static getUser = () => JSON.parse(localStorage.getItem('user'));

  static getAdminToken = () => localStorage.getItem('AdminToken');

  static getAdminRefreshToken = () => localStorage.getItem('AdminRefreshToken');

  static getDecodedToken = () => {
    let decoded = null;

    try {
      decoded = JwtDecode(this.getToken());
    } catch (err) {
      logout();
    }

    return decoded;
  };

  static isLocked = () => {
    const ACCOUNT_LOCKOUT_MINUTES = 30;
    const now = moment().tz('Europe/Sofia');
    const { lockedDateTimeUTC } = this.getUser();

    const castedDate = moment(lockedDateTimeUTC).tz('Europe/Sofia');
    const targetDate = castedDate
      ? moment(castedDate).add('m', ACCOUNT_LOCKOUT_MINUTES).tz('Europe/Sofia')
      : null;

    return targetDate && now.isBefore(targetDate);
  };

  static isActive = () => this.getUser().active;

  static getLockDate = () => {
    const ACCOUNT_LOCKOUT_MINUTES = 30;
    const { lockedDateTimeUTC } = this.getUser();

    const castedDate = moment(lockedDateTimeUTC).tz('Europe/Sofia');
    const targetDate = castedDate
      ? moment(castedDate).add('m', ACCOUNT_LOCKOUT_MINUTES).tz('Europe/Sofia')
      : null;
    return targetDate;
  };

  static isInRole = (role) => this.getUser()?.role === role;

  static isInOneOfRoles = (roles) => !!roles.find((r) => r === this.getUser()?.role);

  static isLoggedInAsFredyOrellana = () => +this.getUser()?.id === 525; // for user dianak@sortpak.com (Fredy Orellana)

  static isLoggedInAsDianaKnadjian = () => +this.getUser()?.id === 67; // for user dianak@sortpak.com (Diana Knadjian)

  static isLoggedInAsIrmaGarcia = () => +this.getUser()?.id === 116; // for user irma@sortpak.com (Irma Garcia)

  static isLoggedInAsMikeAyvazyan = () => +this.getUser()?.id === 845; // for user mikeayvazyan@sortpak.com (Mike Ayvazyan)

  static isLoggedInAsPriorityPharmacies = () => this.isLoggedInAsDianaKnadjian() || this.isLoggedInAsMikeAyvazyan() || this.isLoggedInAsIrmaGarcia();
}

export default accountHelpers;
